import { render } from "preact";
import { App } from "./app.tsx";
import "./style.css";
import * as Sentry from "@sentry/react";
import { AppStateProvider } from "./context/AppStateContext.tsx";
import { RendererProvider } from "./context/RendererContext.tsx";
import { ArtworkProvider } from "./context/ArtworkContext.tsx";
import { UserFormProvider } from "./hooks/useUserForm.tsx";
import { ImageTargetProvider } from "./context/ImageTargetContext.tsx";

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://7b95db0a4bf9a91c4a72511e0564756e@o1388406.ingest.us.sentry.io/4508928893779968",
    integrations: [],
  });
}

render(
  <AppStateProvider>
    <RendererProvider>
      <ArtworkProvider>
        <UserFormProvider>
          <ImageTargetProvider>
            <App />
          </ImageTargetProvider>
        </UserFormProvider>
      </ArtworkProvider>
    </RendererProvider>
  </AppStateProvider>,
  document.getElementById("app")!
);
